
<template>
  <div>
    <div class="title-container" shadow="never" style="margin-top: 0px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div>
      <div>
        <el-button type="primary" size="medium" class="operator-btn" style="margin-right: 0px; width: 120px;"
                   icon="el-icon-circle-plus-outline" @click="showAddDlg()">添加</el-button>
      </div>
    </div>
    <div class="table-container" style="margin-top: 0px;">
      <el-table
              :key="refreshTimer"
              :data="tableData"
              :header-cell-style="{'text-align':'center'}"
              :cell-style="{'text-align':'center'}"
              max-height="680"
              v-loading="listLoading" border>
        <el-table-column prop="number" label="序列"  width="120"></el-table-column>
        <el-table-column prop="name" label="互动内容" ></el-table-column>
        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <el-button @click="handleDeleteOne(scope.row)" type="warning"  size="mini" icon="el-icon-delete" plain>删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-card class="operate-container" style="width: 100%; margin-top: 15px;" shadow="never">
      <el-button type="primary" class="operator-btn" @click="handleUpdate" style="margin-right: 0px; width: 120px;">保存</el-button>
    </el-card>
    <el-dialog
      title="添加"
      :visible.sync="visibleAddNew"
      width="50%"
      center>
      <div class="root-container">
        <el-form ref="refInputWorker" label-width="140px">
          <el-form-item  label="互动内容:" >
            <el-input v-model="newItem" style="width: 300px;"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleAddNew = false">取消</el-button>
        <el-button type="primary" @click="handeleAdd()">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

  import globaldata from "../../../../../utils/globaldata";
  import commonUtils from "../../../../../utils/commonUtils";
  import messageUtils from "../../../../../utils/messageUtils";
  import {EClassServiceItemType} from "../../../../../utils/enumsUtil";
  import {getClassServiceItem, updateClassServiceItem} from "../../../../../api/StoreSetting";

  export default {
    name: 'ServiceInteractiveContentBs',
    data() {
      return {
        listLoading: true,
        visibleAddNew :false,
        newItem:"",

        //表单结果
        tableData: [
        ],
        createParam:{
          name:"",
        },
        deleteParam :{
          name:"",
        },

      }
    },
    created(){

    },
    mounted() {

    },
    methods: {
      flechList(){
        this.listLoading = true;
        let param = {
          id:globaldata.getAdminStore().storeFrontId,
          type:EClassServiceItemType().SW_INTERACTIVE_CONTENT.v
        }
        getClassServiceItem(param).then(response => {
          this.listLoading = false;
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          this.refreshData(data.options);
        })

      },

      //刷新页面数据
      refreshData(data){
        if (commonUtils.isObjectNull(data)){
          return;
        }
        let list = data;
        this.tableData = [];
        for (let i = 0;i< list.length;++i){
          if (list[i].length <=0){
            continue;
          }
          let data = {
            name:list[i],
          };
          this.tableData.push(data);
        }
        this.refreshTableData();

      },
      handleDeleteOne(row){
        this.$confirm('确认要删除该内容吗?', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.tableData.splice(row.number-1,1);
          this.refreshTableData();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消删除'
          });
        });
      },
      showAddDlg(){
        this.visibleAddNew = true;
      },
      handeleAdd(){
        if (commonUtils.isStringNull(this.newItem)){
          messageUtils.errorMsg(this,"不能添加空数据");
          return;
        }
        if (this.checkSameItem(this.newItem) == false){
          return;
        }
        let item = {
          name :this.newItem
        }
        this.tableData.push(item);
        this.refreshTableData();
        this.visibleAddNew = false;
      },
      checkSameItem(item){
        for (let i = 0;i< this.tableData.length;++i){
          if (item == this.tableData[i].name){
            messageUtils.errorMsg(this,"不能添加重复数据");
            return false;
          }
        }
      },
      refreshTableData(){
        let d = [];
        for (let i  = 0;i< this.tableData.length;++i){
          let data = {
            number : i+1 ,
            name:this.tableData[i].name,
          };
          d.push(data);
        }

        this.tableData = d;
      },


      /**
       * 保存跟新
       */
      handleUpdate(){

        let o = [];
        for (let i = 0;i<this.tableData.length;++i){
          o.push(this.tableData[i].name);
        }
        let param = {
          storeFrontId:globaldata.getAdminStore().storeFrontId,
          type:EClassServiceItemType().SW_INTERACTIVE_CONTENT.v,
          item:{
            options:o,
            isOpen:true,
          },
        }
        updateClassServiceItem(param).then(response =>
        {
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          if (data == true){
            messageUtils.successMsg(this,response.message)
          } else {
            messageUtils.errorMsg(this,response.message)
          }

        })
      },
      reloadData(){
        this.flechList();
      }




    }
  }
</script>






// WEBPACK FOOTER //
// src/views/my-store/store-setting/after-service-cf/components/ServiceInteractiveContentBs.vue